
import { Card, Table, useNavigate } from 'external/react'

import DualBadge from 'components/DualBadge'
import Switch from 'components/Switch'
import useAdmin from 'context/admin-context/hook'

const OffersPage = () => {
	const navigate = useNavigate();
	const {offers, toggleOfferStatus} = useAdmin()
	return (
				<Card.Body>
						<Table bordered hover>
							<thead>
								<tr>
									<th>Titulo</th>
									<th>Tipo</th>
                  <th>Creado en</th>
									<th>Estado</th>
								</tr>
							</thead>
							<tbody>
								{offers.map((item, index) => {
									return (
										<tr key={index}>
											<td className='text-capitalize'>{item.name}</td>
											<td>{item.frequency_unit_name}</td>
                      <td>{item.start_date}</td>
											<td>
												<div className='d-flex align-items-center justify-content-between'>
													<DualBadge active={item.active} labels={['Activo', 'Inactivo']} badgeProps={{style: {width: '70px'}}}/>
													<Switch onChange={() => toggleOfferStatus(item)} defaultChecked={item.active} />
													<span className='span--edit' onClick={() => navigate(`/admin/offers/configuration/${item.id}`) }>Editar</span>
												</div>
											</td>
										</tr>
									)
								})}
							</tbody>
						</Table>
					</Card.Body>
  )
}

export {OffersPage as default}